import React from 'react';
import { Message } from '../ChatUpdated/ChatUpdated.styled';

const ChatPinnedMessage = ({ pinnedMessagesArray: [pinnedMessage], messagesArray, settings }) => (
	<>
		{pinnedMessage && !pinnedMessage.blocked && (
			<Message
				primaryColor={settings?.playerStyling?.primaryColor ?? '#126cfc'}
				name={pinnedMessage.sender.name}
				content={pinnedMessage.message?.text}
				replyContent={
					pinnedMessage.recipient.replyMessageId && messagesArray.find((x) => x.id === pinnedMessage.recipient.replyMessageId).message.text
				}
				isPinned={true}
				isAdmin={pinnedMessage.sender.admin}
			/>
		)}
	</>
);

export { ChatPinnedMessage };
